import { ColumnsType } from "antd/lib/table"
import { News } from "../../../graphql/fragments"
import { formatNewsTime } from "../../../utils"

export default (): ColumnsType<News>[number] => ({
  title: "End Date",
  dataIndex: "endAt",
  render: formatNewsTime,
})
